// Definiciones de rutas para el Centro de Ayuda

const helpRoutes = [
  { path: "guias", name: "Guías de Inicio Rápido", title: "Guías de Inicio Rápido" },
  { path: "faq", name: "Preguntas Frecuentes", title: "FAQ (Preguntas Frecuentes)" },
];

// Mapeo a objetos con importación dinámica y meta
const routes = helpRoutes.map((item) => {
  if (item.dividerTitle) {
    return { dividerTitle: item.dividerTitle };
  }
  return {
    path: `/${item.path}`,
    name: item.name,
    component: () => import(`@/views/ayuda/${capitalize(item.path)}.vue`),
    meta: { title: item.title },
  };
});

// Función para capitalizar y formatear el nombre del componente
function capitalize(str) {
  return str
    .split("-")
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
    .join("");
}

export { routes };
